/*
 * Raise the on-screen keyboard from a tap on something that is not a field
 * ("Add coupon"), for a field that only appears a moment later (a sheet).
 *
 * iOS raises the keyboard only for a focus() made inside the tap itself, and
 * the sheet's field does not exist yet then. So the tap focuses a stand-in
 * input at once — up comes the keyboard — and the real field takes focus over
 * from it when it mounts (autoFocus). A focus that moves from one input to
 * another keeps the keyboard up. The stand-in is removed as soon as focus
 * leaves it, or after a second if nothing takes over.
 */
export function primeKeyboard() {
  const proxy = document.createElement("input");
  proxy.type = "text";
  proxy.setAttribute("aria-hidden", "true");
  proxy.tabIndex = -1;
  /* Top of the screen, so focusing it scrolls nothing; 16px so iOS does not
     zoom; invisible and untouchable. */
  Object.assign(proxy.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "1px",
    height: "1px",
    opacity: "0",
    fontSize: "16px",
    pointerEvents: "none",
  });
  document.body.appendChild(proxy);
  proxy.focus({ preventScroll: true });

  const remove = () => {
    proxy.removeEventListener("blur", remove);
    proxy.remove();
  };
  proxy.addEventListener("blur", remove);
  window.setTimeout(() => {
    if (document.activeElement === proxy) proxy.blur();
    remove();
  }, 1000);
}
